import React from 'react';
import { ApiEndpoint } from '../components/api/ApiEndpoint';
import { virtualAccountsEndpoints } from '../data/apiData';

export const Collections: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-10 pb-8 border-b border-gray-100">
        <h1 className="text-2xl font-bold text-gray-900 mb-3">Collections (Virtual Accounts)</h1>
        <p className="text-base text-gray-500 leading-relaxed max-w-2xl mb-4">
          Create virtual accounts to collect payments without exposing your main account details.
          Choose between reserved accounts for ongoing customer relationships or temporary accounts for one-time invoices.
        </p>
        <div className="flex flex-wrap gap-2">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-white border border-gray-200 rounded-full text-xs font-medium text-gray-600">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
            Reserved Accounts
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-white border border-gray-200 rounded-full text-xs font-medium text-gray-600">
            <span className="h-1.5 w-1.5 rounded-full bg-blue-400" />
            Temporary Accounts
          </span>
        </div>
      </div>

      <div className="space-y-6">
        {virtualAccountsEndpoints.map((endpoint) => (
          <ApiEndpoint key={endpoint.id} endpoint={endpoint} />
        ))}
      </div>
    </div>
  );
};
